// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.value.vector2D {\n  width: 30% !important;\n}\ninput.value.vector2D.x {\n  margin-right: 0px;\n  width: 70px !important;\n  border-radius: 4px;\n}\ninput.value.vector2D.y {\n  width: 65px !important;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
